import { parseRouteParamToInt } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_CONVERSATION_ID = 0;

export type ReactToListingSuccessRouteParams = {
  conversationID: number;
};

export type ReactToListingSuccessRouteParamsString = {
  conversationID: string;
};

export const ReactToListingSuccess = defineRoute<
  ReactToListingSuccessRouteParams,
  ReactToListingSuccessRouteParamsString
>({
  pathname: '/react-to-listing/success/[conversationID]',
  nlPathname: '/reageer-op-advertentie/success/[conversationID]',
  options: { isLandlordRoute: false, isPublic: false },
  routeParamsStringifier: routeParams => {
    return {
      conversationID: routeParams.conversationID.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      conversationID:
        parseRouteParamToInt(routeParamsString.conversationID) ||
        DEFAULT_CONVERSATION_ID,
    };
  },
});
